import { useContext, useEffect } from "react";
import { KeysMatching, useValidator, Validator } from "..";
import Entry, { EntryProps } from "../../Form/Entry/Entry";
import SchemaFormContext from '../SchemaFormContext';

export interface SchemaEntryProps<T extends object> extends Omit<EntryProps, "value" | "error"> {
    for: KeysMatching<T, string | undefined>;
    validate?: Validator<string> | Validator<string>[];
};

export function SchemaEntry<T extends object>({"for": key, required, validate, ...props}: SchemaEntryProps<T>)
{
    const context = useContext(SchemaFormContext);
    const value = context.getValue(key);
    const error = context.getError(key)

    const validator = useValidator(validate || [], []);

    useEffect(() => {
        context.register(key, !!required, validator);
    }, [key, required, validator]);

    useEffect(() => {
        if (error) {
            context.validateSelf(key);
        }
    }, [value]);

    const onBlur = () => {
        context.onBlur(key);
        props.onBlur && props.onBlur();
    }

    const onChange = (value: string) => {
        context.setValue(key, value);
        props.onChange && props.onChange(value);
    }

    return (
        <Entry {...props}
            error={error}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
}
